/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** PrincipalType */
export enum PrincipalType {
  ControlPerson = 'controlPerson',
  BeneficialOwner = 'beneficialOwner',
}

/** PrincipalDocumentType */
export enum PrincipalDocumentType {
  IdentityVerification = 'identityVerification',
  AddressVerification = 'addressVerification',
  Custom = 'custom',
}

/** PrincipalDocumentScope */
export enum PrincipalDocumentScope {
  AllPrincipals = 'allPrincipals',
  ControlPerson = 'controlPerson',
  BeneficialOwners = 'beneficialOwners',
}

/** LegalEntityType */
export enum LegalEntityType {
  SoleProprietorship = 'soleProprietorship',
  Llc = 'llc',
  PrivateCompany = 'privateCompany',
  PublicCompanyUnlisted = 'publicCompanyUnlisted',
  PublicCompanyListed = 'publicCompanyListed',
  CharitableOrganizationNotForProfit = 'charitableOrganizationNotForProfit',
  Partnership = 'partnership',
}

/** BusinessInfoRevisionStatus */
export enum BusinessInfoRevisionStatus {
  Draft = 'draft',
  PendingReview = 'pendingReview',
  WaitingForInformation = 'waitingForInformation',
  Rejected = 'rejected',
  Superseded = 'superseded',
}

/** BusinessInfoRevisionKind */
export enum BusinessInfoRevisionKind {
  Initial = 'initial',
  Update = 'update',
  Supplement = 'supplement',
}

/** BusinessInfoPhase */
export enum BusinessInfoPhase {
  Materialized = 'materialized',
  Staged = 'staged',
}

/** BusinessDocumentType */
export enum BusinessDocumentType {
  EntityVerification = 'entityVerification',
  AddressVerification = 'addressVerification',
  EinVerification = 'einVerification',
  OwnershipVerification = 'ownershipVerification',
  Custom = 'custom',
}

/** AbandonBusinessInfoDraftRequestDto */
export interface AbandonBusinessInfoDraftRequestDto {
  /**
   * @minLength 0
   * @maxLength 2000
   */
  reason?: string;
}

/** AddressDto */
export interface AddressDto {
  /**
   * @minLength 1
   * @maxLength 250
   */
  streetAddress1?: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  streetAddress2?: string;
  /**
   * @minLength 2
   * @maxLength 150
   */
  city?: string;
  /**
   * @minLength 2
   * @maxLength 25
   */
  state?: string;
  /**
   * @minLength 2
   * @maxLength 25
   */
  zipCode?: string;
  /**
   * @minLength 2
   * @maxLength 25
   */
  country?: string;
  /** Indicates if the address is a valid US address */
  isValid: boolean;
}

/** AttachBusinessInfoDraftDocumentRequestDto */
export interface AttachBusinessInfoDraftDocumentRequestDto {
  /**
   * @minLength 1
   * @maxLength 100
   */
  obligationKey: string;
  /** @minLength 1 */
  uploadSessionId: string;
  principalId?: string;
}

/** BusinessDocumentObligationDto */
export interface BusinessDocumentObligationDto {
  key: string;
  label: string;
  documentType: BusinessDocumentType;
  /** @format int32 */
  minCount: number;
  /** @format int32 */
  maxCount?: number;
  description?: string;
}

/** BusinessInfoDraftDocumentDto */
export interface BusinessInfoDraftDocumentDto {
  id?: string;
  obligationKey: string;
  description?: string;
  businessDocumentType?: BusinessDocumentType;
  principalDocumentType?: PrincipalDocumentType;
  principalId?: string;
  fileId: string;
  /** @format date-time */
  created: string;
}

/** BusinessInfoDraftDto */
export interface BusinessInfoDraftDto {
  businessInfoId: string;
  type: BusinessInfoRevisionKind;
  status: BusinessInfoRevisionStatus;
  legalName?: string;
  legalEntityType?: LegalEntityType;
  ein?: string;
  mccCode?: string;
  summary?: string;
  businessAddress?: AddressDto;
  /** @format date */
  startDate?: string;
  principals: BusinessInfoDraftPrincipalDto[];
  documents: BusinessInfoDraftDocumentDto[];
  resolvedRequirement?: BusinessInfoRequirementDto;
  /** Explanation from the workflow change that set the current status. Present for rejected and waiting-for-information; null otherwise. */
  statusReason?: string;
}

/** BusinessInfoDraftPrincipalDto */
export interface BusinessInfoDraftPrincipalDto {
  id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  address?: AddressDto;
  ssn?: string;
  /** @format date */
  dateOfBirth?: string;
  driverLicense?: DriverLicenseDto;
  type?: PrincipalType;
  /** @format int32 */
  ownership?: number;
}

/** BusinessInfoDraftPrincipalRequestDto */
export interface BusinessInfoDraftPrincipalRequestDto {
  /**
   * @minLength 0
   * @maxLength 100
   */
  firstName?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  lastName?: string;
  /**
   * @format email
   * @minLength 0
   * @maxLength 250
   */
  email?: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  phone?: string;
  address?: AddressDto;
  /**
   * @minLength 0
   * @maxLength 20
   */
  ssn?: string;
  /** @format date */
  dateOfBirth?: string;
  driverLicense?: DriverLicenseDto;
  type?: PrincipalType;
  /**
   * @format int32
   * @min 0
   * @max 100
   */
  ownership?: number;
}

/** BusinessInfoItemDto */
export interface BusinessInfoItemDto {
  id: string;
  displayLabel: string;
  isPrimary: boolean;
  /** Indicates the current stage of this BI, `Materialized` means available for Biz identity, `Staged` means in creation or update workflow. */
  phase: BusinessInfoPhase;
  /** Active workflow status; null when no open workflow on this identity. */
  status?: BusinessInfoRevisionStatus;
  /** Workflow kind for UI; null when no open workflow. Aligns with BusinessInfoDraftDto.Type. */
  type?: BusinessInfoRevisionKind;
  /** @format date-time */
  submitted?: string;
}

/** BusinessInfoRequirementDto */
export interface BusinessInfoRequirementDto {
  name: string;
  formPreset: string;
  businessDocuments: BusinessDocumentObligationDto[];
  principalDocuments: PrincipalDocumentObligationDto[];
}

/** BusinessInfosDto */
export interface BusinessInfosDto {
  items: BusinessInfoItemDto[];
}

/** DriverLicenseDto */
export interface DriverLicenseDto {
  /**
   * @minLength 1
   * @maxLength 50
   */
  number?: string;
  /**
   * @minLength 2
   * @maxLength 25
   */
  state?: string;
}

/** InitBusinessInfoDraftRequestDto */
export interface InitBusinessInfoDraftRequestDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  legalName: string;
}

/** PatchBusinessInfoDraftRequestDto */
export interface PatchBusinessInfoDraftRequestDto {
  /**
   * @minLength 0
   * @maxLength 150
   */
  legalName?: string;
  legalEntityType?: LegalEntityType;
  /**
   * @minLength 0
   * @maxLength 20
   */
  ein?: string;
  /**
   * @minLength 0
   * @maxLength 10
   */
  mccCode?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  summary?: string;
  businessAddress?: AddressDto;
  /** @format date */
  startDate?: string;
}

/** PrincipalDocumentObligationDto */
export interface PrincipalDocumentObligationDto {
  key: string;
  label: string;
  documentType: PrincipalDocumentType;
  /** @format int32 */
  minCount: number;
  /** @format int32 */
  maxCount?: number;
  description?: string;
  principalScope: PrincipalDocumentScope;
  /** @format int32 */
  ownershipThresholdPercent?: number;
  businessInfoPrincipalId?: string;
}

/** RequestUploadSessionDto */
export interface RequestUploadSessionDto {
  /**
   * @minLength 1
   * @maxLength 250
   */
  fileName: string;
  /**
   * @format int32
   * @min 1
   * @max 9223372036854776000
   */
  fileSize: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  contentType: string;
}

/** UploadSessionDto */
export interface UploadSessionDto {
  sessionId: string;
  endpoint: string;
  method: string;
  fields: Record<string, string>;
  /** @format date-time */
  expires: string;
}

/** WithdrawBusinessInfoDraftRequestDto */
export interface WithdrawBusinessInfoDraftRequestDto {
  /**
   * @minLength 0
   * @maxLength 2000
   */
  reason?: string;
}

export interface GetBusinessInfosParams {
  phases?: BusinessInfoPhase[];
}

export interface GetDraftParams {
  /** @format int64 */
  businessInfoId: string;
}

export interface StartDraftParams {
  /** @format int64 */
  businessInfoId: string;
}

export interface PatchDraftParams {
  /** @format int64 */
  businessInfoId: string;
}

export interface SubmitDraftParams {
  /** @format int64 */
  businessInfoId: string;
}

export interface WithdrawDraftParams {
  /** @format int64 */
  businessInfoId: string;
}

export interface AbandonDraftParams {
  /** @format int64 */
  businessInfoId: string;
}

export interface SetPrimaryParams {
  /** @format int64 */
  businessInfoId: string;
}

export interface CreateUploadSessionParams {
  /** @format int64 */
  businessInfoId: string;
}

export interface AttachDocumentParams {
  /** @format int64 */
  businessInfoId: string;
}

export interface DetachDocumentParams {
  /** @format int64 */
  businessInfoId: string;
  /** @format int64 */
  documentId: string;
}

export interface AddPrincipalParams {
  /** @format int64 */
  businessInfoId: string;
}

export interface UpdatePrincipalParams {
  /** @format int64 */
  businessInfoId: string;
  /** @format int64 */
  principalId: string;
}

export interface RemovePrincipalParams {
  /** @format int64 */
  businessInfoId: string;
  /** @format int64 */
  principalId: string;
}
